export default {
  uuid: '',
  pluginId: '',
  projectId: '',
  storeDistricts: [],
  enCodePluginId: '',
  isLoading: false,
  xgw: '',
};
